export const customFormFieldFormatCategory = Object.freeze({
  None: 0,
  Currency: 1,
  CurrencyNoCents: 2,
  DecimalNumber: 3,
  IntegerNumber: 4,
});
